import Vue from "vue";
import { format } from "date-fns";

Vue.filter('formatDateTime', function (value) {
	if (!value) return "";
	return format(value, "DD/MM/YYYY HH:mm");
});

Vue.filter('formatDate', function (value) {
	if (!value) return "";
	return format(value, "DD/MM/YYYY");
});
